import { coreInitiativesFilesGetAsyncSlice } from './get';
import { CoreInitiativesFilesName } from './name';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';
import { PatchInitiativeFileRequest } from '@api';

export const coreInitiativesFilesUpdateSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: CoreInitiativesFilesName,
	state: coreInitiativesFilesGetAsyncSlice.asyncState,
	target: (request: PatchInitiativeFileRequest) => (file) => file.id === request.id,
	update: (request: PatchInitiativeFileRequest) => (file) => ({
		...file,
		name: request.name ?? ''
	})
});
